import { DROPDOWN_CONFIG } from "./constants";
/**
 * Calculates the dropdown position (top, left) for the action menu, opening upwards if not enough space below.
 * Returns null if refs are not available.
 */
export const getDropdownPosition = ({ buttonRef, menuRef }) => {
  const buttonElement = buttonRef.current;
  if (!buttonElement) return null;
  const buttonRect = buttonElement.getBoundingClientRect();
  let dropdownLeft = buttonRect.left - DROPDOWN_CONFIG.WIDTH - DROPDOWN_CONFIG.GAP;
  if (dropdownLeft < DROPDOWN_CONFIG.PADDING) dropdownLeft = DROPDOWN_CONFIG.PADDING;
  const dropdownActualHeight = menuRef.current?.offsetHeight || DROPDOWN_CONFIG.ESTIMATED_HEIGHT;
  const availableSpaceBelow = window.innerHeight - (buttonRect.bottom + 2);
  const availableSpaceAbove = buttonRect.top - DROPDOWN_CONFIG.PADDING;
  const dropdownTop =
    availableSpaceBelow < dropdownActualHeight && availableSpaceAbove >= dropdownActualHeight
      ? Math.max(buttonRect.bottom - dropdownActualHeight, DROPDOWN_CONFIG.PADDING)
      : buttonRect.top + 2;
  return { top: dropdownTop, left: dropdownLeft };
};

/**
 * Checks if the dropdown menu has left the visible table area and closes it if necessary.
 * Returns early if required refs or table elements are missing.
 */
export const shouldCloseDropdown = ({ menuRef, buttonRef, setActionMenuVisible }) => {
  const dropdownElement = menuRef.current;
  const buttonElement = buttonRef.current;
  if (!dropdownElement || !buttonElement) return;
  const dropdownRect = dropdownElement.getBoundingClientRect();
  const tableElement = document.querySelector(".license-management-table");
  if (!tableElement) return;
  const tableRect = tableElement.getBoundingClientRect();
  const tableHeaderElement = tableElement.querySelector(".ag-header");
  const tableHeaderBottom = tableHeaderElement ? tableHeaderElement.getBoundingClientRect().bottom : tableRect.top;
  const isDropdownOutOfBounds = dropdownRect.bottom > tableRect.bottom || dropdownRect.top <= tableHeaderBottom;
  if (isDropdownOutOfBounds) {
    setActionMenuVisible(false);
  }
};
